/* PDP colour-family reviews. Original reviews and the submission form stay in Judge.me. */
(() => {
  'use strict';
  if (customElements.get('ss-family-reviews')) return;
  const PREFIX = 'ss-family-reviews__';
  const VERSION = '2';
  const STAR = 'M12 2.4l2.97 6.02 6.64.96-4.8 4.68 1.13 6.62L12 17.55l-5.94 3.13 1.13-6.62-4.8-4.68 6.64-.96Z';
  const REPLY = 'M8.8,10c.2,0,.3,0,.4,0,1.7,0,3-1.4,3.1-3.1,0,0,0-.2,0-.4s0-.3,0-.4c0-1.7-1.4-3-3.1-3.1,0,0-.2,0-.4,0h-1.5c-.4,0-.8-.3-.8-.8s.3-.8.8-.8h1.5c.2,0,.3,0,.5,0,2.4.1,4.4,2.1,4.5,4.5,0,.1,0,.2,0,.5h0c0,.3,0,.4,0,.5-.1,2.4-2.1,4.4-4.5,4.5-.1,0-.2,0-.5,0h-4l1.7,1.7c.3.3.3.8,0,1.1-.3.3-.8.3-1,0l-3-3c-.3-.3-.3-.8,0-1.1l3-3c.3-.3.8-.3,1.1,0,.3.3.3.8,0,1.1h0l-1.7,1.7h3.9Z';
  let sequence = 0;
  const element = (tag, name, text) => {
    const node = document.createElement(tag);
    if (name) node.className = PREFIX + name;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const button = (name, text, action) => {
    const node = element('button', name, text);
    node.type = 'button';
    node.addEventListener('click', action);
    return node;
  };
  const svgElement = (tag, attrs) => {
    const node = document.createElementNS('http://www.w3.org/2000/svg', tag);
    Object.entries(attrs).forEach(([key, value]) => node.setAttribute(key, value));
    return node;
  };
  function stars(score, small = false) {
    const root = element('span', 'stars' + (small ? ' ' + PREFIX + 'stars--small' : ''));
    root.setAttribute('role', 'img');
    root.setAttribute('aria-label', `${score.toLocaleString('nl-NL', { maximumFractionDigits: 2 })} van 5 sterren`);
    for (let i = 0; i < 5; i++) {
      const svg = svgElement('svg', { viewBox: '0 0 24 24', class: PREFIX + 'star', 'aria-hidden': 'true' });
      const clipId = 'ss-review-star-' + (++sequence);
      const defs = svgElement('defs', {});
      const clip = svgElement('clipPath', { id: clipId });
      clip.append(svgElement('rect', { x: 0, y: 0, width: 24 * Math.min(1, Math.max(0, score - i)), height: 24 }));
      defs.append(clip);
      svg.append(defs, svgElement('path', { d: STAR, fill: 'none', stroke: 'currentColor', 'stroke-width': 1.3 }),
        svgElement('path', { d: STAR, fill: 'currentColor', 'clip-path': `url(#${clipId})` }));
      root.append(svg);
    }
    return root;
  }
  function productHandle(value) {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin) return '';
      return decodeURIComponent(url.pathname.match(/\/products\/([^/]+)\/?$/)?.[1] || '');
    } catch (_) { return ''; }
  }
  function mediaUrl(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' && (url.origin === location.origin || /(^|\.)(judge\.me|judgeme\.com|shopify\.com)$/.test(url.hostname)) ? url.href : '';
    } catch (_) { return ''; }
  }
  function bodyText(node) {
    if (!node) return '';
    const copy = node.cloneNode(true);
    copy.querySelectorAll('script,style').forEach(n => n.remove());
    copy.querySelectorAll('br').forEach(n => n.replaceWith('\n'));
    copy.querySelectorAll('p').forEach(n => n.append('\n'));
    return copy.textContent.trim().replace(/\n{3,}/g, '\n\n');
  }
  function parseReviews(html) {
    const template = document.createElement('template');
    template.innerHTML = html;
    return Array.from(template.content.querySelectorAll('.jdgm-rev[data-review-id]')).map(node => {
      const text = selector => node.querySelector(selector)?.textContent.trim() || '';
      const photos = Array.from(node.querySelectorAll('.jdgm-rev__pic-link')).map(link => ({
        full: mediaUrl(link.getAttribute('href')),
        thumb: mediaUrl(link.querySelector('img')?.getAttribute('data-src') || link.querySelector('img')?.getAttribute('src'))
      })).filter(photo => photo.full && photo.thumb);
      const videoContainer = node.querySelector('.jdgm-rev__vids');
      const videos = Array.from(new Set(Array.from(videoContainer?.querySelectorAll('video[src], source[src], a[href]') || [])
        .map(video => mediaUrl(video.getAttribute('src') || video.getAttribute('href')))
        .filter(url => /\.(mp4|webm)(\?|$)/i.test(url))));
      // Keep the native widget if a provider adds a video format we cannot safely render.
      if (videoContainer?.children.length && !videos.length) throw new Error('Unsupported review video');
      return {
        id: node.getAttribute('data-review-id'),
        handle: productHandle(node.getAttribute('data-product-url') || ''),
        rating: Number(node.querySelector('[data-score]')?.getAttribute('data-score')),
        author: text('.jdgm-rev__author') || 'Anoniem',
        title: text('.jdgm-rev__title'), body: bodyText(node.querySelector('.jdgm-rev__body')),
        date: node.querySelector('time[datetime]')?.getAttribute('datetime') || '',
        verified: node.getAttribute('data-verified-buyer') === 'true',
        reply: bodyText(node.querySelector('.jdgm-rev__reply-content')), photos, videos
      };
    });
  }
  async function pool(items, action) {
    let index = 0;
    const results = new Array(items.length);
    await Promise.all(Array.from({ length: Math.min(3, items.length) }, async () => {
      while (index < items.length) { const current = index++; results[current] = await action(items[current]); }
    }));
    return results;
  }
  async function sourceReviews(shop, source, signal, bypassCache) {
    const cacheKey = ['ss-colour-reviews', VERSION, shop, source.id, source.count, source.updated].join(':');
    if (!bypassCache) {
      try {
        const cached = JSON.parse(sessionStorage.getItem(cacheKey));
        if (cached && Date.now() - cached.at < 300000 && Array.isArray(cached.reviews)) return cached.reviews;
      } catch (_) { /* Storage can be unavailable in private browsing. */ }
    }
    const page = async (number, size) => {
      const url = new URL('https://cdn.judge.me/reviews/reviews_for_widget');
      url.search = new URLSearchParams({ shop_domain: shop, platform: 'shopify', product_id: source.id,
        page: number, per_page: size, sort_by: 'created_at', sort_dir: 'desc',
        ts: source.updated || Math.floor(Date.now() / 1200000) });
      const response = await fetch(url, { credentials: 'omit', signal });
      if (!response.ok) throw new Error('Review feed unavailable');
      const data = await response.json();
      if (!Number.isInteger(data.total_count) || data.total_count < 0 || typeof data.html !== 'string') throw new Error('Invalid review feed');
      return { count: data.total_count, reviews: parseReviews(data.html) };
    };
    // A changing feed can repeat a review across page boundaries. Retry once with different boundaries.
    for (const size of [25, 23]) {
      const first = await page(1, size);
      if (first.count > 5000) throw new Error('Review feed exceeds safe page limit');
      const pages = await pool(Array.from({ length: Math.ceil(first.count / size) - 1 }, (_, i) => i + 2), n => page(n, size));
      const all = [first, ...pages];
      const unique = new Map(all.flatMap(result => result.reviews).map(review => [review.id, review]));
      if (all.some(result => result.count !== first.count) || unique.size !== first.count) continue;
      const reviews = Array.from(unique.values());
      if (reviews.some(review => !review.id || !review.handle || !Number.isInteger(review.rating) || review.rating < 1 || review.rating > 5)) throw new Error('Incomplete review data');
      try { sessionStorage.setItem(cacheKey, JSON.stringify({ at: Date.now(), reviews })); } catch (_) { /* Cache is optional. */ }
      return reviews;
    }
    throw new Error('Review feed changed while loading');
  }

  class FamilyReviews extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.sort = 'newest'; this.rating = 0; this.firstReview = 0;
      this.querySelector('[data-family-retry]')?.addEventListener('click', () => this.load(true));
      this.load();
    }
    disconnectedCallback() { this.controller?.abort(); this.clearCarousel(); this.started = false; }
    async load(bypassCache = false) {
      this.controller?.abort();
      this.controller = new AbortController();
      const controller = this.controller;
      const signal = controller.signal;
      const timeout = setTimeout(() => controller.abort(), 20000);
      this.querySelector('[data-family-retry]').hidden = true;
      try {
        this.config = JSON.parse(this.querySelector('[data-family-config]').textContent);
        if (!this.config.current?.id || !/^[\w-]+\.myshopify\.com$/.test(this.config.shop)) throw new Error('Invalid configuration');
        if (this.config.familySize > 250) throw new Error('Colour collection exceeds supported size');
        const members = this.config.members.some(member => member.id === this.config.current.id) ? this.config.members : [];
        this.members = new Map([...members, this.config.current].map(member => [member.handle, member]));
        const sources = Array.from(this.members.values()).filter(member => member.id === this.config.current.id || member.count > 0 || member.hasContent);
        const results = await pool(sources, source => sourceReviews(this.config.shop, source, signal, bypassCache));
        if (signal.aborted) throw new Error('Review loading cancelled');
        const unique = new Map();
        results.flat().forEach(review => {
          if (!this.members.has(review.handle)) return;
          const prior = unique.get(review.id);
          if (prior && (prior.rating !== review.rating || prior.handle !== review.handle)) throw new Error('Conflicting review data');
          unique.set(review.id, review);
        });
        this.reviews = Array.from(unique.values());
        if (this.rating && !this.reviews.some(review => review.rating === this.rating)) { this.rating = 0; this.firstReview = 0; }
        this.average = this.reviews.length ? this.reviews.reduce((sum, review) => sum + review.rating, 0) / this.reviews.length : 0;
        this.render();
        this.updateBadge();
        this.updateSchema();
        this.dataset.state = 'ready';
        this.querySelector('[data-family-notice]').hidden = true;
      } catch (error) {
        if (!this.isConnected || this.controller !== controller) return;
        // Never present a partial family count as its total. Leave the original product widget available.
        this.dataset.state = 'error';
        this.querySelector('[data-family-output]').hidden = true;
        const notice = this.querySelector('[data-family-notice]');
        notice.textContent = 'De reviews van alle kleuren konden niet worden geladen. Hieronder staan de beschikbare reviews van dit product.';
        notice.hidden = false;
        this.querySelector('[data-family-retry]').hidden = false;
      } finally { clearTimeout(timeout); }
    }
    render() {
      this.clearCarousel();
      const output = this.querySelector('[data-family-output]');
      output.replaceChildren(); output.hidden = false;
      const layout = element('div', 'layout');
      const summary = element('div', 'summary');
      const count = this.reviews.length;
      if (count) {
        summary.append(stars(this.average), element('strong', 'average', this.average.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' van de 5'));
      }
      summary.append(element('p', 'count', count ? `Gebaseerd op ${count} ${count === 1 ? 'beoordeling' : 'beoordelingen'}` : 'Nog geen beoordelingen'));
      if (this.members.size > 1) summary.append(element('p', 'scope', 'Deze beoordelingen gaan over dit model in verschillende kleuren. Bij elke review zie je welke kleur is beoordeeld.'));
      if (count) {
        const histogram = element('div', 'histogram');
        for (let score = 5; score > 0; score--) {
          const amount = this.reviews.filter(review => review.rating === score).length;
          const filter = button('rating-filter', undefined, () => {
            this.rating = this.rating === score ? 0 : score; this.firstReview = 0; this.render();
            this.querySelectorAll('.' + PREFIX + 'rating-filter')[5 - score]?.focus({ preventScroll: true });
          });
          filter.setAttribute('aria-label', `${score} sterren: ${amount} ${amount === 1 ? 'beoordeling' : 'beoordelingen'}`);
          filter.setAttribute('aria-pressed', String(this.rating === score));
          filter.disabled = !amount;
          const bar = element('span', 'bar');
          const fill = element('span', 'bar-fill'); fill.style.width = `${amount / count * 100}%`; bar.append(fill);
          filter.append(stars(score, true), bar, element('span', 'rating-count', amount)); histogram.append(filter);
        }
        summary.append(histogram);
      }
      summary.append(button('write', 'Schrijf een beoordeling', () => this.openForm()));
      layout.append(summary);
      const main = element('div', 'list');
      if (count) {
        const controls = element('div', 'controls');
        const label = element('label', '', 'Sorteren op');
        const select = element('select');
        [['newest', 'Nieuwste eerst'], ['oldest', 'Oudste eerst'], ['highest', 'Meeste sterren'], ['lowest', 'Minste sterren']].forEach(([value, text]) => {
          const option = element('option', '', text); option.value = value; option.selected = value === this.sort; select.append(option);
        });
        select.addEventListener('change', () => { this.sort = select.value; this.firstReview = 0; this.render(); this.querySelector('select')?.focus({ preventScroll: true }); });
        label.append(select); controls.append(label);
        if (this.rating) controls.append(button('reset', 'Toon alle beoordelingen', () => {
          this.rating = 0; this.firstReview = 0; this.render(); this.querySelector('select')?.focus({ preventScroll: true });
        }));
        main.append(controls);
        const sorted = this.reviews.filter(review => !this.rating || review.rating === this.rating).sort((a, b) => {
          const date = (Date.parse(b.date) || 0) - (Date.parse(a.date) || 0);
          const rank = this.sort === 'highest' ? b.rating - a.rating : this.sort === 'lowest' ? a.rating - b.rating : 0;
          return rank || (this.sort === 'oldest' ? -date : date) || a.id.localeCompare(b.id);
        });
        this.renderCarousel(main, sorted);
      } else {
        main.append(element('p', 'text', 'Heb je dit product besteld? Deel je ervaring en help andere klanten bij hun keuze.'));
      }
      layout.append(main); output.append(layout);
      this.resizeCarousel?.();
    }
    clearCarousel() {
      this.carouselObserver?.disconnect();
      this.carouselMedia?.removeEventListener('change', this.carouselBreakpoint);
      this.resizeCarousel = null;
    }
    renderCarousel(main, reviews) {
      const media = window.matchMedia('(max-width: 767px)');
      const size = media.matches ? 1 : 2;
      const track = element('div', 'track');
      track.id = 'ss-family-track-' + (++sequence);
      track.tabIndex = 0;
      track.setAttribute('role', 'region');
      track.setAttribute('aria-roledescription', 'carrousel');
      track.setAttribute('aria-label', 'Klantbeoordelingen, horizontaal bladeren');
      const pages = [];
      for (let start = 0; start < reviews.length; start += size) {
        const page = element('div', 'page');
        page.setAttribute('role', 'group');
        page.setAttribute('aria-label', `Beoordelingen ${start + 1} tot ${Math.min(start + size, reviews.length)} van ${reviews.length}`);
        reviews.slice(start, start + size).forEach(review => page.append(this.reviewCard(review)));
        pages.push(page); track.append(page);
      }
      let index = Math.min(pages.length - 1, Math.floor((this.firstReview || 0) / size));
      let target = null;
      const footer = element('div', 'pagination');
      const range = element('p', 'range');
      range.setAttribute('role', 'status'); range.setAttribute('aria-atomic', 'true');
      const navigation = element('div', 'navigation');
      navigation.hidden = pages.length < 2;
      const step = () => pages.length > 1 ? pages[1].offsetLeft - pages[0].offsetLeft : track.clientWidth;
      const go = next => {
        target = Math.max(0, Math.min(pages.length - 1, next));
        track.scrollTo({ left: target * step(), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      const arrow = (direction, label, delta) => {
        const control = button('arrow', undefined, () => go((target ?? index) + delta));
        control.setAttribute('aria-label', label); control.setAttribute('aria-controls', track.id);
        const circle = element('span');
        const icon = element('i'); icon.className = 'ss-icon-arrow-' + direction; icon.setAttribute('aria-hidden', 'true');
        circle.append(icon); control.append(circle); return control;
      };
      const previous = arrow('left', 'Vorige beoordelingen', -1);
      const next = arrow('right', 'Volgende beoordelingen', 1);
      navigation.append(previous, next); footer.append(range, navigation); main.append(track, footer);
      const update = () => {
        this.firstReview = index * size;
        const start = this.firstReview + 1;
        const end = Math.min(this.firstReview + size, reviews.length);
        range.textContent = `${start === end ? start : start + '–' + end} van ${reviews.length} ${reviews.length === 1 ? 'beoordeling' : 'beoordelingen'}`;
        previous.disabled = index === 0; next.disabled = index === pages.length - 1;
        pages.forEach((page, number) => {
          const inactive = number !== index;
          if (inactive && page.contains(document.activeElement)) track.focus({ preventScroll: true });
          page.inert = inactive;
          page.setAttribute('aria-hidden', String(inactive));
        });
      };
      track.addEventListener('scroll', () => {
        const width = step();
        if (!track.clientWidth || !width) return;
        const visible = Math.max(0, Math.min(pages.length - 1, Math.round(track.scrollLeft / width)));
        if (visible !== index) { index = visible; update(); }
        if (target !== null && Math.abs(track.scrollLeft - target * width) < 2) target = null;
      }, { passive: true });
      ['pointerdown', 'touchstart', 'wheel'].forEach(event => track.addEventListener(event, () => { target = null; }, { passive: true }));
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        const keys = { ArrowLeft: (target ?? index) - 1, ArrowRight: (target ?? index) + 1, Home: 0, End: pages.length - 1 };
        if (event.key in keys) { event.preventDefault(); go(keys[event.key]); }
      });
      this.carouselMedia = media;
      this.carouselBreakpoint = () => this.render();
      media.addEventListener('change', this.carouselBreakpoint);
      let lastWidth = 0;
      this.resizeCarousel = () => {
        // Tabs are initially hidden; align again when opened or when the viewport changes.
        const width = track.clientWidth;
        if (!width) { lastWidth = 0; return; }
        if (width === lastWidth) return;
        lastWidth = width; target = null;
        track.scrollTo({ left: index * step(), behavior: 'instant' });
      };
      this.carouselObserver = new ResizeObserver(this.resizeCarousel);
      this.carouselObserver.observe(track);
      update();
    }
    reviewCard(review) {
      const article = element('article', 'article'); article.dataset.reviewId = review.id; article.tabIndex = -1;
      const top = element('div', 'review-top'); top.append(stars(review.rating));
      if (Number.isFinite(Date.parse(review.date))) {
        const date = element('time', 'date', new Date(review.date).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' }));
        date.dateTime = review.date; top.append(date);
      }
      article.append(top, element('span', 'author', review.author));
      if (review.verified) article.append(element('span', 'verified', 'Geverifieerd'));
      const member = this.members.get(review.handle);
      if (this.members.size > 1 && member) {
        const product = element('a', 'product'); product.href = '/products/' + encodeURIComponent(member.handle);
        const imageUrl = mediaUrl(member.image);
        if (imageUrl) { const img = element('img'); img.src = imageUrl; img.alt = ''; img.loading = 'lazy'; img.width = 42; img.height = 42; product.append(img); }
        const text = element('span'); text.append(element('small', '', 'Beoordeeld product'), document.createTextNode(member.title)); product.append(text); article.append(product);
      }
      if (review.title) article.append(element('h3', 'title', review.title));
      if (review.body) article.append(element('p', 'text', review.body));
      if (review.photos.length) {
        const photos = element('div', 'photos');
        review.photos.forEach((photo, index) => {
          const open = button('photo', undefined, () => this.openPhoto(photo, review.author, open));
          open.setAttribute('aria-label', `Bekijk klantfoto ${index + 1} van ${review.author}`);
          const img = element('img'); img.src = photo.thumb; img.alt = `Klantfoto van ${review.author}`; img.loading = 'lazy'; img.width = 76; img.height = 76;
          open.append(img); photos.append(open);
        }); article.append(photos);
      }
      review.videos.forEach(src => {
        const video = element('video', 'video'); video.src = src; video.controls = true; video.preload = 'none';
        video.setAttribute('aria-label', 'Klantvideo van ' + review.author); article.append(video);
      });
      if (review.reply) {
        const reply = element('div', 'reply'); const heading = element('div', 'reply-heading');
        const icon = svgElement('svg', { viewBox: '0 0 16 16', 'aria-hidden': 'true' }); icon.append(svgElement('path', { d: REPLY }));
        heading.append(icon, document.createTextNode('Reactie van Super-snel.nl'));
        reply.append(heading, element('p', '', review.reply)); article.append(reply);
      }
      return article;
    }
    openPhoto(photo, author, trigger) {
      const dialog = element('dialog', 'dialog'); dialog.setAttribute('aria-label', 'Klantfoto van ' + author);
      dialog.append(button('', 'Sluiten ×', () => dialog.close()));
      const img = element('img'); img.src = photo.full; img.alt = 'Klantfoto van ' + author; dialog.append(img);
      dialog.addEventListener('close', () => { dialog.remove(); trigger.focus(); });
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      this.append(dialog); dialog.showModal();
    }
    updateBadge() {
      const top = document.querySelector('.producttop__reviews');
      if (!top) return;
      top.querySelectorAll(':scope > .reviews, :scope > .reviews__separator, .ss-family-review-badge').forEach(node => node.remove());
      if (!this.reviews.length) return;
      const badge = button('', undefined, () => this.openPanel()); badge.className = 'ss-family-review-badge';
      badge.append(stars(this.average, true), element('span', '', `${this.reviews.length} ${this.reviews.length === 1 ? 'review' : 'reviews'}`));
      badge.setAttribute('aria-label', `${this.reviews.length} ${this.reviews.length === 1 ? 'review' : 'reviews'}, ${this.average.toLocaleString('nl-NL', { maximumFractionDigits: 2 })} van 5 sterren. Bekijk beoordelingen.`);
      top.prepend(badge);
    }
    openPanel() {
      const panel = this.closest('#ProductReview');
      if (panel?.getAttribute('aria-hidden') === 'true' || panel?.style.display === 'none') {
        const control = window.matchMedia('(min-width: 992px)').matches ? document.getElementById('tab-ProductReview') : document.querySelector('.productinfo-tabs__collapsible-link[aria-controls="ProductReview"]');
        control?.click();
      }
      requestAnimationFrame(() => this.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }));
    }
    async openForm() {
      this.openPanel();
      if (this.formOpening) return this.formOpening;
      this.formOpening = (async () => {
        const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
        const find = () => this.querySelector('.jdgm-write-rev-link, .jdgm-write-rev-btn');
        const deadline = Date.now() + 10000;
        let attempts = 0;
        while (this.isConnected && Date.now() < deadline) {
          // Opening a hidden tab can rebuild Judge.me's form. Wait for its real event handlers.
          await delay(100);
          if (!this.querySelector('#judgeme_product_reviews.jdgm--done-setup-widget')) continue;
          const write = find();
          if (!write) continue;
          if (write.getAttribute('aria-expanded') !== 'true' && attempts < 3) {
            write.click(); attempts++;
            await delay(250);
          }
          if (find()?.getAttribute('aria-expanded') === 'true') {
            this.querySelector('.jdgm-form-wrapper')?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
            return;
          }
          if (attempts >= 3) break;
        }
        if (this.isConnected) {
          const notice = this.querySelector('[data-family-notice]'); notice.textContent = 'Het reviewformulier is nog niet beschikbaar. Probeer het over enkele ogenblikken opnieuw.'; notice.hidden = false;
        }
      })();
      try { await this.formOpening; } finally { this.formOpening = null; }
    }
    updateSchema() {
      // Keep the rendered Product aggregate consistent; never change Organization or unrelated products.
      const visit = value => {
        if (!value || typeof value !== 'object') return;
        const types = [].concat(value['@type'] || []);
        if (types.includes('Product') && [value.url, value['@id']].some(url => typeof url === 'string' && productHandle(url.split('#')[0]) === this.config.current.handle)) {
          if (this.reviews.length) value.aggregateRating = { '@type': 'AggregateRating', ratingValue: Number(this.average.toFixed(2)), reviewCount: this.reviews.length, bestRating: 5, worstRating: 1 };
          else delete value.aggregateRating;
        }
        Object.values(value).forEach(child => { if (typeof child === 'object') { if (Array.isArray(child)) child.forEach(visit); else visit(child); } });
      };
      document.querySelectorAll('script[type="application/ld+json"]').forEach(script => {
        try { const data = JSON.parse(script.textContent); visit(data); script.textContent = JSON.stringify(data).replace(/</g, '\\u003c'); } catch (_) { /* Other apps may emit non-JSON scripts. */ }
      });
    }
  }
  customElements.define('ss-family-reviews', FamilyReviews);
})();
